<div class="col-md-12">
  <form [formGroup]="thermicForm" (ngSubmit)="onSubmit()" class="row g-3">

    <!-- Tarih + Konum -->
    <div class="row g-2 align-items-center">
      <!-- Tarih -->
      <div class="col-12 col-md-6">
        <div class="input-group">
          <span class="input-group-text" id="sDate-label">Tarih</span>
          <input id="sDate" class="form-control" placeholder="yyyy-aa-gg" name="dp" ngbDatepicker #d="ngbDatepicker"
            formControlName="sDate" [minDate]="minDate" [maxDate]="maxDate" aria-label="Tarih"
            aria-describedby="sDate-label" />
          <button class="btn btn-outline-secondary" type="button" (click)="d.toggle()" title="Tarih Seç">
            <i class="fa fa-calendar"></i>
          </button>
        </div>
      </div>

      <!-- Konum -->
      <div class="col-12 col-md-6">
        <div class="row align-items-center gx-2">
          <div class="col-10">
            <div class="input-group">
              <span class="input-group-text" id="location-label">Konum</span>
              <select class="form-select" formControlName="location" (change)="setLocation($event.target.value)"
                aria-label="Konum" aria-describedby="location-label">
                <option value="Ayas">Ayaş</option>
                <option value="Aksehir">Akşehir</option>
                <option value="Alanya">Alanya</option>
                <option value="Corum">Çorum</option>
                <option value="Oludeniz_1700">Ölüdeniz 1700m</option>
                <option value="Ormanli">Ormanlı</option>
                <option value="Uregil">Üreğil</option>

                <option value="0">Özel Koordinat</option>
              </select>
            </div>
          </div>
          <div class="col-2 d-flex">
            <span role="button" class="text-success ms-md-2 ms-0 align-self-center" (click)="getCurrentLocation()"
              style="cursor: pointer;" title="Mevcut Konumu Kullan">
              <i class="fa-solid fa-location-crosshairs responsive-icon"></i>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-2">
      <!-- Left Half: Lat, Lng, Elevation -->
      <div class="col-12 col-md-6">
        <div class="row g-2">
          <div class="col-12 col-md-6">
            <div class="input-group">
              <span class="input-group-text" id="latitude-label">Enlem</span>
              <input type="number" class="form-control" id="latitude" formControlName="latitude"
                placeholder="örn. 39.9208" aria-label="Enlem" aria-describedby="latitude-label" />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="input-group">
              <span class="input-group-text" id="longitude-label">Boylam</span>
              <input type="number" class="form-control" id="longitude" formControlName="longitude"
                placeholder="örn. 32.8541" aria-label="Boylam" aria-describedby="longitude-label" />
            </div>
          </div>
          <div class="col-12">
            <div class="input-group">
              <span class="input-group-text" id="elevation-label">Yükseklik</span>
              <input type="number" class="form-control" id="elevation" formControlName="elavation" placeholder="1500"
                aria-label="Yükseklik" aria-describedby="elevation-label" />
            </div>
          </div>
        </div>
      </div>

      <!-- Right Half: Model and Forecast Duration -->
      <div class="col-12 col-md-6">
        <div class="d-flex flex-column gap-2 h-100">

          <!-- Weather Model Dropdown -->
          <div class="input-group">
            <span class="input-group-text" id="weatherModel-label">Model</span>
            <select id="weatherModel" class="form-select" formControlName="weatherModel" aria-label="Model"
              aria-describedby="weatherModel-label">
              <option value="ecmwf_ifs025">ECMWF</option>
              <option value="icon_eu">ICON EU</option>
            </select>
          </div>

          <!-- Forecast Duration Radios with Label -->
          <div class="input-group">
            <span class="input-group-text" id="forecast-label">Tahmin Süresi</span>
            <div class="form-control d-flex justify-content-around">
              <div class="form-check form-check-inline mb-0">
                <input class="form-check-input" type="radio" id="duration12" value="12"
                  formControlName="forecastDuration" />
                <label class="form-check-label" for="duration12">12 saatlik</label>
              </div>
              <div class="form-check form-check-inline mb-0">
                <input class="form-check-input" type="radio" id="duration24" value="24"
                  formControlName="forecastDuration" />
                <label class="form-check-label" for="duration24">24 saatlik</label>
              </div>
            </div>
          </div>

        </div>
      </div>


    </div>

    <!-- Submit -->
    <div class="col-12">
      <button type="submit" class="btn btn-success" [disabled]="!thermicForm.valid">
        Hesapla
      </button>
    </div>
  </form>

</div>
<div class="mt-3">
  <section>

    <div class="card-body" style="padding: 0.25rem !important;">
      <div class="row">
        <div class="col-md-4">
        </div>
        <div class="col-md-4">
          <div class="col-12" *ngIf="setFlySimulatorLink">
            <a (click)="openFlySimulator()" class="btn btn-link display-9 font-weight-bold">
              <img src="assets/images/yeni-gif.gif" alt="FlySimulator" class="img-fluid" style="max-width: 40px;">
              Uçuş Simülatörü</a>
          </div>
          <h5 class="card-title font-weight-bold">{{selectedLocation}}</h5>
          <p class="card-text">{{today | date:"dd MMM yyyy HH:mm"}}</p>
          <p class="display-9 font-weight-bold">{{result?.dailyParameters.maxTemp ?'En Yüksek Sıcaklık
            '+result?.dailyParameters.maxTemp+'°C':''}} </p>
          <p class="display-9 font-weight-bold"> {{result?.dailyParameters.precipitationProbability? 'Yağış İhtimali
            '+result?.dailyParameters.precipitationProbability+'%':''}}</p>
        </div>
        <div class="col-md-4 d-flex justify-content-center justify-content-md-end ">
          <button type="button" class="btn btn-link p-0 border-0"
            *ngIf="this.thermicForm.controls['location'].value !== '0' && result?.dailyParameters.radarUrl && isSelectedDateToday()"
            (click)="openRadarModal(result?.dailyParameters.radarUrl)" title="Radarı Büyüt" style="display: contents;">
            <img [src]="result?.dailyParameters.radarUrl + 'ppi15.jpg'" alt="Bölgesel Radar Görseli"
              class="img-fluid w-50 radar-image-container">
          </button>
        </div>

        <ng-template #radarModalContent let-modal>
          <div class="modal-header">
            <h4 class="modal-title">Bölgesel Radar Görseli</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
          </div>
          <div class="modal-body text-center" *ngIf="isSelectedDateToday()">
            <app-radar [radarImageUrl]="fullRadarImageUrlInModal"></app-radar>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-dark" (click)="modal.close('Close click')">Kapat</button>
          </div>
        </ng-template>

        <div *ngIf="location  !== null ; else noMapData" class="map-container col-md-12">
          <app-map [latitude]="this.location.latitude" [longitude]="this.location.longitude" [placeName]=""
            [windDirection]="result?.windDirection850hPa" [windSpeed]="result?.windSpeed850hPa"
            [thermalIndex700hPa]="result?.altitude700Index" [thermalIndex850hPa]="result?.altitude850Index"
            [windGustSpeed]="result?.hourlyGust" [cloudCover]="result?.cloudCover">
          </app-map>

        </div>
        <ng-template #noMapData>
          <p class="message">Harita verisi mevcut değildir.</p>
        </ng-template>
      </div>
      <div class="card" *ngIf="result">
        <div class="pt-2">
          <div class="col-12 d-flex justify-content-center">
            <div class="border rounded p-3" style=" width: 100%; height: 130px; overflow-y: auto;">
              <div class="text-start"> Yakında AI destekli hava durumu yorumlama eklenecektir</div>
              <!-- <div [innerHTML]="result.indexComment" class="text-start"></div> -->
            </div>
          </div>
          <div class="col-12 pt-2">
            <!-- Mobile View -->
            <div class="d-block d-md-none">
              <div class="accordion" id="hourlyAccordion">
                <div class="accordion-item" *ngFor="let hI of result?.hourlyIndexModelList; index as i">
                  <h2 class="accordion-header" [id]="'heading' + i">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                      [attr.data-bs-target]="'#collapse' + i" aria-expanded="false"
                      [attr.aria-controls]="'collapse' + i" (click)="onMouseEnter(hI)">
                      {{ hI.hour }}
                    </button>
                  </h2>
                  <div [id]="'collapse' + i" class="accordion-collapse collapse" [attr.aria-labelledby]="'heading' + i"
                    data-bs-parent="#hourlyAccordion">
                    <div class="accordion-body custom-padding ">
                      <div class="accordion-body text-start">
                        <!-- thermal Index Card -->
                        <div class="card mb-2">
                          <div class="card-header bg-light fw-bold">Termik İndeksi</div>
                          <div class="card-body">
                            <table class="table table-striped table-bordered w-100">
                              <tr>
                                <td>3000m İndeksi <button type="button" class="btn btn-link p-0 m-0 align-baseline"
                                    data-bs-toggle="modal" data-bs-target="#tIModal">
                                    <i class="fa fa-info-circle text-primary"></i>
                                  </button></td>
                                <td class="align-middle text-center">
                                  {{ result.hourlyIndexModelList[i].altitudeHourly700Index |
                                  number: '1.0-0' }}</td>
                              </tr>
                              <tr>
                                <td>1500m İndeksi</td>
                                <td class="align-middle text-center">
                                  {{ result.hourlyIndexModelList[i].altitudeHourly850Index |
                                  number: '1.0-0' }}</td>
                              </tr>
                            </table>
                          </div>
                        </div>
                        <!-- Rüzgar Card -->
                        <div class="card mb-2">
                          <div class="card-header bg-light fw-bold">Rüzgar</div>
                          <div class="card-body">
                            <table class="table table-striped table-bordered w-100" style="margin-left: -8px;">
                              <thead>
                                <tr>
                                  <th>Seviye</th>
                                  <th>Yön° / Adı</th>
                                  <th>Hız km/s</th>
                                  <th>Yer Yüzü Hamle km/s</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>3000m
                                    <button type="button" class="btn btn-link p-0 m-0 align-baseline"
                                      data-bs-toggle="modal" data-bs-target="#windModal">
                                      <i class="fa fa-info-circle text-primary"></i>
                                    </button>
                                  </td>
                                  <td>{{ result.hourlyWindModelList[i].windDirection_700hPa }}° / {{
                                    result.hourlyWindModelList[i].windDirectionName700hPa }}</td>
                                  <td [ngClass]="result.hourlyWindModelList[i].speedTextCss700"> {{
                                    result.hourlyWindModelList[i].windSpeed_700hPa }}</td>
                                  <td rowspan="3" class="align-middle"
                                    [ngClass]="result.hourlyWindModelList[i].gustsTextCss10m"> {{
                                    result.hourlyWindModelList[i].windGusts10m }}</td>
                                </tr>
                                <tr>
                                  <td>1500m</td>
                                  <td>{{ result.hourlyWindModelList[i].windDirection_850hPa }}° / {{
                                    result.hourlyWindModelList[i].windDirectionName850hPa }}</td>
                                  <td [ngClass]="result.hourlyWindModelList[i].speedTextCss850"> {{
                                    result.hourlyWindModelList[i].windSpeed_850hPa }}</td>
                                </tr>
                                <tr *ngIf="selectedModel === 'icon_eu'">
                                  <td>1000m</td>
                                  <td>{{ result.hourlyWindModelList[i].windDirection_900hPa }}° / {{
                                    result.hourlyWindModelList[i].windDirectionName900hPa }}</td>
                                  <td [ngClass]="result.hourlyWindModelList[i].speedTextCss900">{{
                                    result.hourlyWindModelList[i].windSpeed_900hPa }}</td>
                                </tr>
                                <tr *ngIf="selectedModel === 'ecmwf_ifs025'">
                                  <td>800m</td>
                                  <td>{{ result.hourlyWindModelList[i].windDirection_925hPa }}° / {{
                                    result.hourlyWindModelList[i].windDirectionName925hPa }}</td>
                                  <td [ngClass]="result.hourlyWindModelList[i].speedTextCss925">{{
                                    result.hourlyWindModelList[i].windSpeed_925hPa }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <!-- Bulut & CAPE Card -->
                        <div class="card mb-2">
                          <div class="card-header bg-light fw-bold">Bulut ve CAPE</div>
                          <div class="card-body">
                            <table class="table table-striped table-bordered">
                              <tbody>
                                <tr>
                                  <td>Toplam Bulut</td>
                                  <td>{{ result.hourlyCloudCoverModelList[i].cloudCover }}%</td>
                                </tr>
                                <tr>
                                  <td>Yağış / Tipi</td>
                                  <td>
                                    {{getPrecipitationTypeLabel(result.hourlyCloudCoverModelList[i].precipitation_type,result.hourlyCloudCoverModelList[i].precipitation
                                    )}}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Alçak Bulut
                                    <button type="button" class="btn btn-link p-0 m-0 align-baseline"
                                      data-bs-toggle="modal" data-bs-target="#ecmwfCloudModal">
                                      <i class="fa fa-info-circle text-primary"></i>
                                    </button>
                                  </td>
                                  <td>{{ result.hourlyCloudCoverModelList[i].cloudCoverLow }}%</td>
                                </tr>
                                <tr>
                                  <td>Orta Bulut</td>
                                  <td>{{ result.hourlyCloudCoverModelList[i].cloudCoverMid }}%</td>
                                </tr>
                                <tr>
                                  <td>Yüksek Bulut</td>
                                  <td>{{ result.hourlyCloudCoverModelList[i].cloudCoverHigh }}%</td>
                                </tr>
                                <tr *ngIf="selectedModel === 'icon_eu'">
                                  <td>Termik Bulut Tabanı
                                    <button type="button" class="btn btn-link p-0 m-0 align-baseline"
                                      data-bs-toggle="modal" data-bs-target="#ccbModal">
                                      <i class="fa fa-info-circle text-primary"></i>
                                    </button>
                                  </td>
                                  <td>{{ result.hourlyCloudCoverModelList[i].hourlyConvectiveCloudBase < 500 ? '-' :
                                      result.hourlyCloudCoverModelList[i].hourlyConvectiveCloudBase + ' m' }}</td>
                                </tr>
                                <tr>
                                  <td>CAPE <button type="button" class="btn btn-link p-0 m-0 align-baseline"
                                      data-bs-toggle="modal" data-bs-target="#capeModal">
                                      <i class="fa fa-info-circle text-primary"></i>
                                    </button></td>
                                  <td>{{ result.hourlyCloudCoverModelList[i].hourlyCape < 50 ? '-' :
                                      result.hourlyCloudCoverModelList[i].hourlyCape }} j/kg</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <!-- Sıcaklık & Nem Card -->
                        <div class="card mb-2">
                          <div class="card-header bg-light fw-bold">Sıcaklık ve Nem</div>
                          <div class="card-body">
                            <table class="table table-striped table-bordered w-100">
                              <tbody>
                                <tr>
                                  <td>3000m Sıcaklık</td>
                                  <td>{{ result.hourlyTempModelList[i].temperature_700hPa }} °C</td>
                                </tr>
                                <tr>
                                  <td>3000m Çiy</td>
                                  <td>{{ result.hourlyDewPoint[i].dewPoint700hPa }} °C</td>
                                </tr>
                                <tr>
                                  <td>3000m Nem <button type="button" class="btn btn-link p-0 m-0 align-baseline"
                                      data-bs-toggle="modal" data-bs-target="#humidityModal">
                                      <i class="fa fa-info-circle text-primary"></i>
                                    </button></td>
                                  <td>{{ result.hourlyRelativeHumidityModelList[i].relativeHumidity_700hPa }}%</td>
                                </tr>
                                <tr>
                                  <td>1500m Sıcaklık</td>
                                  <td>{{ result.hourlyTempModelList[i].temperature_850hPa }} °C</td>
                                </tr>
                                <tr>
                                  <td>1500m Çiy</td>
                                  <td>{{ result.hourlyDewPoint[i].dewPoint850hPa }} °C</td>
                                </tr>
                                <tr>
                                  <td>1500m Nem</td>
                                  <td>{{ result.hourlyRelativeHumidityModelList[i].relativeHumidity850hPa }}%</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Desktop View (existing table) -->
            <div class="d-none d-md-block">
              <div class="top-scrollbar-container" #topScroller>
                <div [style.width.px]="tableContentWidth" class="top-scrollbar-inner-content"></div>
              </div>

              <div class="table-responsive" #tableResponsive>
                <table class="table table-striped table-bordered table-sticky">
                  <tbody>
                    <tr>
                      <td>Saat</td>
                      <td *ngFor="let hI of result?.hourlyIndexModelList" class="align-middle text-center td-click"
                        (mouseenter)="onMouseEnter(hI)"> {{hI.hour}}</td>
                    </tr>
                    <tr>
                      <td>1500m Termik İndeksi <button type="button" class="btn btn-link p-0 m-0 align-baseline"
                          data-bs-toggle="modal" data-bs-target="#tIModal">
                          <i class="fa fa-info-circle text-primary"></i>
                        </button></td>
                      <td appHighlightColumn *ngFor="let hI of result?.hourlyIndexModelList"
                        class="align-middle text-center" [ngbTooltip]="hI.hour" container="body">
                        {{hI.altitudeHourly850Index
                        |
                        number: '1.0-0' }}</td>
                    </tr>
                    <tr>
                      <td>3000m Termik İndeksi</td>
                      <td appHighlightColumn *ngFor="let hI of result?.hourlyIndexModelList"
                        class="align-middle text-center" [ngbTooltip]="hI.hour" container="body">
                        {{hI.altitudeHourly700Index
                        |
                        number: '1.0-0' }}</td>
                    </tr>
                    <tr class="border-top-custom">
                      <td>3000m Rüzgar (km/s)
                        <button type="button" class="btn btn-link p-0 m-0 align-baseline" data-bs-toggle="modal"
                          data-bs-target="#windModal">
                          <i class="fa fa-info-circle text-primary"></i>
                        </button>
                      </td>
                      <td appHighlightColumn *ngFor="let hW of result?.hourlyWindModelList; index as i"
                        [ngClass]="hW.speedTextCss700" class="align-middle text-center" [ngbTooltip]="hW.hour"
                        container="body">
                        {{hW.windDirection_700hPa}}°/{{hW.windSpeed_700hPa}} <br> {{hW.windDirectionName700hPa}}

                      </td>
                    </tr>
                    <tr>
                      <td>1500m Rüzgar (km/s)
                        <button type="button" class="btn btn-link p-0 m-0 align-baseline" data-bs-toggle="modal"
                          data-bs-target="#windModal">
                          <i class="fa fa-info-circle text-primary"></i>
                        </button>
                      </td>
                      <td appHighlightColumn *ngFor="let hW of result?.hourlyWindModelList; index as i"
                        [ngClass]="hW.speedTextCss850" class="align-middle text-center" [ngbTooltip]="hW.hour"
                        container="body">
                        {{hW.windDirection_850hPa}}°/{{hW.windSpeed_850hPa}} <br> {{hW.windDirectionName850hPa}}

                      </td>
                    </tr>
                    <tr *ngIf="selectedModel === 'icon_eu'">
                      <td>1000m Rüzgar (km/s)
                      </td>
                      <td appHighlightColumn *ngFor="let hW of result?.hourlyWindModelList; index as i"
                        [ngClass]="hW.speedTextCss900" class="align-middle text-center" [ngbTooltip]="hW.hour"
                        container="body">
                        {{hW.windDirection_900hPa}}°/{{hW.windSpeed_900hPa}} <br> {{hW.windDirectionName900hPa}}
                      </td>
                    </tr>
                    <tr *ngIf="selectedModel === 'ecmwf_ifs025'">
                      <td>800m Rüzgar (km/s)
                      </td>
                      <td appHighlightColumn *ngFor="let hW of result?.hourlyWindModelList; index as i"
                        [ngClass]="hW.speedTextCss925" class="align-middle text-center" [ngbTooltip]="hW.hour"
                        container="body">
                        {{hW.windDirection_925hPa}}°/{{hW.windSpeed_925hPa}} <br> {{hW.windDirectionName925hPa}}
                      </td>
                    </tr>
                    <tr>
                      <td>Yer Yüzü Hamle (km/s) </td>

                      <td appHighlightColumn *ngFor="let hW of result?.hourlyWindModelList; index as i"
                        [ngClass]="hW.gustsTextCss10m" class="align-middle text-center" [ngbTooltip]="hW.hour"
                        container="body"> {{hW.windGusts10m}}
                      </td>
                    </tr>
                    <tr class="border-top-custom">
                      <td>Bulut (%)
                      </td>
                      <td appHighlightColumn *ngFor="let cc of result?.hourlyCloudCoverModelList; index as i"
                        class="align-middle text-center" [ngbTooltip]="cc.hour" container="body">
                        {{cc.cloudCover}}
                      </td>
                    </tr>
                    <tr>
                      <td>Yağış / Tipi
                      </td>
                      <td appHighlightColumn *ngFor="let cc of result?.hourlyCloudCoverModelList; index as i"
                        class="align-middle text-center" [ngbTooltip]="cc.hour" container="body">
                        {{ getPrecipitationTypeLabel(cc.precipitation_type,cc.precipitation ) }}
                      </td>
                    </tr>
                    <!---------------ECMWF cloud cover---------------->

                    <tr *ngIf="selectedModel === 'ecmwf_ifs025'" class=" group-1">
                      <td>Alçak Sev. Bulut (%)
                        <button type="button" class="btn btn-link p-0 m-0 align-baseline" data-bs-toggle="modal"
                          data-bs-target="#ecmwfCloudModal">
                          <i class="fa fa-info-circle text-primary"></i>
                        </button>
                      </td>
                      <td appHighlightColumn *ngFor="let cc of result?.hourlyCloudCoverModelList; index as i"
                        class="align-middle text-center" [ngbTooltip]="cc.hour" container="body">
                        {{cc.cloudCoverLow}}
                      </td>
                    </tr>
                    <tr *ngIf="selectedModel === 'ecmwf_ifs025'" class=" group-1">
                      <td>Ort. Sev. Bulut (%)
                      </td>
                      <td appHighlightColumn *ngFor="let cc of result?.hourlyCloudCoverModelList; index as i"
                        class="align-middle text-center" [ngbTooltip]="cc.hour" container="body">
                        {{cc.cloudCoverMid}}
                      </td>
                    </tr>
                    <tr *ngIf="selectedModel === 'ecmwf_ifs025'" class=" group-1">
                      <td>Yüksek. Sev. Bulut (%)
                      </td>
                      <td appHighlightColumn *ngFor="let cc of result?.hourlyCloudCoverModelList; index as i"
                        class="align-middle text-center" [ngbTooltip]="cc.hour" container="body">
                        {{cc.cloudCoverHigh}}
                      </td>
                    </tr>
                    <!-----------------End ECMWF cloud cover------------------>

                    <tr *ngIf="selectedModel === 'icon_eu'">
                      <td>Termik Bulut Tabanı
                        <button type="button" class="btn btn-link p-0 m-0 align-baseline" data-bs-toggle="modal"
                          data-bs-target="#ccbModal">
                          <i class="fa fa-info-circle text-primary"></i>
                        </button>
                      </td>
                      <td appHighlightColumn *ngFor="let cc of result?.hourlyCloudCoverModelList; index as i"
                        class="align-middle text-center" [ngbTooltip]="cc.hour" container="body">
                        {{ cc.hourlyConvectiveCloudBase < 500 ? '-' : cc.hourlyConvectiveCloudBase+ ' m' }} </td>
                    </tr>
                    <tr>
                      <td>
                        CAPE
                        <button type="button" class="btn btn-link p-0 m-0 align-baseline" data-bs-toggle="modal"
                          data-bs-target="#capeModal">
                          <i class="fa fa-info-circle text-primary"></i>
                        </button>
                      </td>
                      <td appHighlightColumn *ngFor="let cc of result?.hourlyCloudCoverModelList; index as i"
                        class="align-middle text-center" [ngbTooltip]="cc.hour" container="body">
                        {{ cc.hourlyCape < 50 ? '-' : cc.hourlyCape + ' j/kg' }} </td>
                    </tr>
                    <tr class="border-top-custom">
                      <td>
                        Sıcaklık 3000m
                      </td>
                      <td appHighlightColumn *ngFor="let cc of result?.hourlyTempModelList; index as i"
                        class="align-middle text-center" [ngbTooltip]="cc.hour" container="body">
                        <p class="">{{ cc.temperature_700hPa + ' °C' }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Çiy 3000m
                      </td>
                      <td appHighlightColumn *ngFor="let cc of result?.hourlyDewPoint; index as i"
                        class="align-middle text-center" [ngbTooltip]="cc.hour" container="body">
                        <p class="">{{ cc.dewPoint700hPa + ' °C' }}</p>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        Nem 3000m
                        <button type="button" class="btn btn-link p-0 m-0 align-baseline" data-bs-toggle="modal"
                          data-bs-target="#humidityModal">
                          <i class="fa fa-info-circle text-primary"></i>
                        </button>
                      </td>
                      <td appHighlightColumn *ngFor="let cc of result?.hourlyRelativeHumidityModelList; index as i"
                        class="align-middle text-center" [ngbTooltip]="cc.hour" container="body">
                        {{ cc.relativeHumidity_700hPa + ' %'}} </td>
                    </tr>
                    <tr class="border-top-custom-dashed">
                      <td>
                        Sıcaklık 1500m
                      </td>
                      <td appHighlightColumn *ngFor="let cc of result?.hourlyTempModelList; index as i"
                        class="align-middle text-center" [ngbTooltip]="cc.hour" container="body">
                        <p class="">{{ cc.temperature_850hPa + ' °C' }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Çiy 1500m
                      </td>
                      <td appHighlightColumn *ngFor="let cc of result?.hourlyDewPoint; index as i"
                        class="align-middle text-center" [ngbTooltip]="cc.hour" container="body">
                        <p class="">{{ cc.dewPoint850hPa + ' °C' }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Nem 1500m
                      </td>
                      <td appHighlightColumn *ngFor="let cc of result?.hourlyRelativeHumidityModelList; index as i"
                        class="align-middle text-center" [ngbTooltip]="cc.hour" container="body">
                        {{ cc.relativeHumidity850hPa + ' %' }} </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
